import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { LineReveal } from "../site/motion";
import { Btn } from "../site/Buttons";
import { NetworkVisual } from "../site/NetworkVisual";
import { PHONE, PHONE_HREF } from "../../data/site";

export const HomeHero = () => (
  <section data-testid="home-hero" className="relative overflow-hidden bg-white pb-16 pt-32 md:pb-24 md:pt-40 lg:min-h-[100svh]">
    <div className="pointer-events-none absolute inset-0 grid-lines" />
    <div className="pointer-events-none absolute right-0 top-0 h-full w-full bg-mist/70 lg:w-[42%]" style={{ clipPath: "polygon(18% 0, 100% 0, 100% 100%, 0 100%)" }} />
    <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-[1.25fr_1fr]">
      <div>
        <h1 className="text-navy">
          <LineReveal
            lines={["NEXUS ITALIA GROUP"]}
            lineClassName="text-xs font-bold tracking-[0.42em] text-gold-ink sm:text-sm"
          />
          <LineReveal
            className="mt-6 block text-4xl font-bold leading-[1.04] tracking-tight sm:text-5xl lg:text-[4.1rem]"
            lines={["La connessione", "che dà valore", <span key="l3">ai servizi <span className="font-light italic text-gold-ink">sanitari.</span></span>]}
            delay={0.2}
          />
        </h1>
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.75 }}
          className="mt-8 max-w-xl text-base leading-relaxed text-slate2 md:text-lg"
        >
          Organizziamo, coordiniamo e rendiamo accessibili servizi sanitari e sociosanitari attraverso una Centrale Operativa dedicata e una rete qualificata di partner.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.95 }}
          className="mt-10 flex flex-col gap-4 sm:flex-row"
        >
          <Btn to="/servizi" testId="hero-services-btn">Scopri i nostri servizi</Btn>
          <Btn to="/contatti#modulo" variant="ghost" testId="hero-request-btn">Richiedi un servizio</Btn>
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.2 }}
          className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-4 border-t border-navy/10 pt-6"
        >
          <p className="text-sm font-semibold text-navy">
            Nexus organizza. <span className="text-slate2">Nexus coordina.</span> <span className="text-gold-ink">Nexus c'è.</span>
          </p>
          <a href={PHONE_HREF} data-testid="hero-phone-link" className="flex items-center gap-2 text-sm text-slate2 hover:text-navy">
            <Phone className="h-4 w-4 text-gold" strokeWidth={1.5} /> Centrale Operativa <strong className="text-navy">{PHONE}</strong>
          </a>
        </motion.div>
      </div>
      <NetworkVisual />
    </div>
  </section>
);
